var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 100 100",
        fill: "none",
        width: "24",
        height: "24",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_8450_2610)" } }, [
        _c(
          "mask",
          {
            staticStyle: { "mask-type": "luminance" },
            attrs: {
              id: "mask0_8450_2610",
              maskUnits: "userSpaceOnUse",
              x: "0",
              y: "0",
              width: "100",
              height: "100",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M50.7571 0.261719C78.2929 0.261719 99.8857 22.5974 99.8857 50.1474C99.8857 77.6974 77.6071 99.4903 51.0214 99.4903C41.5857 99.4903 37.0143 98.1617 29.65 92.9474C29.1429 92.5903 28.45 92.6831 28.0214 93.1403C22.3571 99.1831 7.85 103.426 7.18571 95.176C7.18571 80.7903 0 71.4474 0 49.876C0 21.5546 23.2214 0.261719 50.7571 0.261719ZM51.5286 24.8117C38.4643 24.126 28.2643 33.1974 26.0143 47.3831C24.15 59.1332 27.45 73.4546 30.2786 74.176C31.4786 74.4832 34.3571 72.276 36.4571 70.2974C36.85 69.926 37.45 69.8617 37.9071 70.1474C41.1786 72.1474 44.8786 73.6474 48.9571 73.8617C62.3714 74.5617 74.2571 64.0617 74.9643 50.6474C75.6643 37.2331 64.9429 25.5046 51.5286 24.8046V24.8117Z",
                fill: "white",
              },
            }),
          ]
        ),
        _c("g", { attrs: { mask: "url(#mask0_8450_2610)" } }, [
          _c("path", {
            attrs: {
              d: "M49.7 50.0811L-12.4071 84.5025C-13.4071 82.6953 -14.3285 80.8453 -15.1714 78.9596L49.6929 50.0811H49.7Z",
              fill: "url(#paint0_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.7 50.0811L-15.1714 78.9596C-16.0143 77.0739 -16.7714 75.1525 -17.4429 73.1953L49.6928 50.0811H49.7Z",
              fill: "url(#paint1_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6998 50.0811L-17.4431 73.1953C-18.1145 71.2453 -18.7002 69.2596 -19.2002 67.2596L49.6998 50.0811Z",
              fill: "url(#paint2_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.7002 50.0811L-19.1998 67.2596C-19.6998 65.2525 -20.1141 63.2311 -20.4355 61.1882L49.693 50.0811H49.7002Z",
              fill: "url(#paint3_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L-20.4289 61.1882C-20.7503 59.1453 -20.986 57.0953 -21.1289 55.0311L49.7068 50.0811H49.6997Z",
              fill: "url(#paint4_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6998 50.0822L-21.1359 55.0322C-21.2788 52.9679 -21.3359 50.9036 -21.3002 48.8394L49.6927 50.0822H49.6998Z",
              fill: "url(#paint5_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6999 50.0819L-21.293 48.839C-21.2573 46.7748 -21.1287 44.7105 -20.9144 42.6533L49.6999 50.0747V50.0819Z",
              fill: "url(#paint6_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.7002 50.0817L-20.9141 42.6603C-20.6998 40.6032 -20.3926 38.5603 -19.9998 36.5317L49.7002 50.0817Z",
              fill: "url(#paint7_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6998 50.0822L-20.0073 36.5322C-19.6145 34.5036 -19.1288 32.4965 -18.5645 30.5107L49.6927 50.0822H49.6998Z",
              fill: "url(#paint8_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.7 50.0801L-18.5571 30.5086C-17.9857 28.5229 -17.3286 26.5658 -16.5928 24.6372L49.7 50.0872V50.0801Z",
              fill: "url(#paint9_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.7001 50.0822L-16.5928 24.6322C-15.8499 22.7036 -15.0285 20.8108 -14.1213 18.9536L49.7001 50.0822Z",
              fill: "url(#paint10_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6999 50.0812L-14.1216 18.9526C-13.2144 17.0955 -12.2287 15.2812 -11.1644 13.5098L49.6999 50.0812Z",
              fill: "url(#paint11_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0809L-11.1646 13.5095C-10.1003 11.7381 -8.95741 10.0166 -7.74312 8.34521L49.6997 50.0809Z",
              fill: "url(#paint12_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.7 50.0818L-7.75 8.34609C-6.53571 6.67466 -5.25 5.06038 -3.89286 3.49609L49.6929 50.0818H49.7Z",
              fill: "url(#paint13_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6998 50.0825L-3.89307 3.49676C-2.53592 1.93962 -1.1145 0.43962 0.371219 -0.996094L49.6927 50.0825H49.6998Z",
              fill: "url(#paint14_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0822L0.371094 -0.996373C1.85681 -2.43209 3.40681 -3.80352 5.01395 -5.10352L49.6997 50.0822Z",
              fill: "url(#paint15_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6999 50.0824L5.01416 -5.10335C6.6213 -6.40335 8.27845 -7.63192 9.99273 -8.78906L49.6999 50.0752V50.0824Z",
              fill: "url(#paint16_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6998 50.0813L9.99268 -8.79016C11.707 -9.94731 13.4641 -11.0259 15.2712 -12.0259L49.6927 50.0813H49.6998Z",
              fill: "url(#paint17_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6996 50.0804L15.271 -12.0267C17.0781 -13.0267 18.9281 -13.9482 20.8139 -14.791L49.6924 50.0733H49.6996V50.0804Z",
              fill: "url(#paint18_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.7002 50.0808L20.8145 -14.7906C22.7002 -15.6334 24.6216 -16.3906 26.5787 -17.062L49.693 50.0737H49.7002V50.0808Z",
              fill: "url(#paint19_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6996 50.0813L26.5781 -17.0544C28.5281 -17.7258 30.5138 -18.3115 32.521 -18.8115L49.6996 50.0885V50.0813Z",
              fill: "url(#paint20_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6996 50.0801L32.521 -18.8199C34.5281 -19.3199 36.5496 -19.7342 38.5924 -20.0557L49.6996 50.0801Z",
              fill: "url(#paint21_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6999 50.0805L38.5928 -20.048C40.6356 -20.3695 42.6856 -20.6052 44.7499 -20.748L49.6999 50.0877V50.0805Z",
              fill: "url(#paint22_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.7 50.0812L44.75 -20.7546C46.8143 -20.8974 48.8786 -20.9546 50.9429 -20.9188L49.7 50.074V50.0812Z",
              fill: "url(#paint23_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0803L50.9426 -20.9126C53.0068 -20.8769 55.0711 -20.7483 57.1283 -20.534L49.7068 50.0803H49.6997Z",
              fill: "url(#paint24_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L57.1211 -20.5332C59.1783 -20.3189 61.2211 -20.0118 63.2497 -19.6189L49.6997 50.0811Z",
              fill: "url(#paint25_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0823L63.2497 -19.6177C65.2783 -19.2248 67.2854 -18.7391 69.2711 -18.1748L49.6997 50.0823Z",
              fill: "url(#paint26_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6995 50.0818L69.271 -18.1753C71.2567 -17.6039 73.2138 -16.9467 75.1424 -16.211L49.6924 50.0818H49.6995Z",
              fill: "url(#paint27_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6995 50.0819L75.1424 -16.2109C77.071 -15.4681 78.9638 -14.6467 80.821 -13.7395L49.6924 50.0819H49.6995Z",
              fill: "url(#paint28_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0827L80.8283 -13.7388C82.6854 -12.8316 84.4997 -11.8459 86.2711 -10.7816L49.6997 50.0827Z",
              fill: "url(#paint29_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0801L86.2711 -10.7842C88.0426 -9.71989 89.764 -8.57704 91.4354 -7.36275L49.6997 50.0801Z",
              fill: "url(#paint30_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0825L91.4354 -7.36035C93.1068 -6.14607 94.7211 -4.86035 96.2854 -3.50321L49.6997 50.0825Z",
              fill: "url(#paint31_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0802L96.2854 -3.5127C97.8426 -2.15555 99.3426 -0.734124 100.778 0.751591L49.6997 50.073V50.0802Z",
              fill: "url(#paint32_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.082L100.778 0.753418C102.214 2.23913 103.585 3.78913 104.885 5.39628L49.6997 50.082Z",
              fill: "url(#paint33_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0817L104.878 5.396C106.178 7.00314 107.407 8.66028 108.564 10.3746L49.6997 50.0817Z",
              fill: "url(#paint34_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6995 50.0812L108.564 10.374C109.721 12.0883 110.8 13.8455 111.8 15.6526L49.6924 50.074H49.6995V50.0812Z",
              fill: "url(#paint35_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0796L111.807 15.6582C112.807 17.4653 113.728 19.3153 114.571 21.2011L49.7068 50.0796H49.6997Z",
              fill: "url(#paint36_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0812L114.564 21.2026C115.407 23.0884 116.164 25.0098 116.835 26.9669L49.6997 50.0812Z",
              fill: "url(#paint37_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6995 50.0811L116.835 26.9668C117.507 28.9168 118.092 30.9025 118.592 32.9097L49.6924 50.0882L49.6995 50.0811Z",
              fill: "url(#paint38_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0804L118.6 32.9019C119.1 34.909 119.514 36.9304 119.835 38.9733L49.6997 50.0804Z",
              fill: "url(#paint39_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6995 50.0803L119.828 38.9731C120.15 41.016 120.385 43.066 120.528 45.1303L49.6924 50.0803H49.6995Z",
              fill: "url(#paint40_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0809L120.535 45.1309C120.678 47.1951 120.735 49.2594 120.7 51.3237L49.7068 50.0809H49.6997Z",
              fill: "url(#paint41_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L120.693 51.3239C120.657 53.3882 120.528 55.4525 120.314 57.5096L49.6997 50.0882V50.0811Z",
              fill: "url(#paint42_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L120.314 57.5025C120.1 59.5596 119.793 61.6025 119.4 63.6311L49.6997 50.0811Z",
              fill: "url(#paint43_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L119.4 63.6311C119.007 65.6596 118.521 67.6668 117.957 69.6525L49.6997 50.0811Z",
              fill: "url(#paint44_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0823L117.957 69.6538C117.385 71.6395 116.728 73.5966 115.993 75.5252L49.6997 50.0752V50.0823Z",
              fill: "url(#paint45_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L115.993 75.5311C115.25 77.4596 114.428 79.3525 113.521 81.2096L49.6997 50.0811Z",
              fill: "url(#paint46_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L113.521 81.2096C112.614 83.0668 111.628 84.8811 110.564 86.6525L49.6997 50.0811Z",
              fill: "url(#paint47_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L110.564 86.6525C109.5 88.4239 108.357 90.1453 107.143 91.8168L49.6997 50.0811Z",
              fill: "url(#paint48_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L107.143 91.8168C105.928 93.4882 104.643 95.1025 103.285 96.6668L49.6997 50.0811Z",
              fill: "url(#paint49_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L103.285 96.6668C101.928 98.2239 100.507 99.7239 99.0211 101.16L49.6997 50.0811Z",
              fill: "url(#paint50_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L99.0211 101.16C97.5354 102.595 95.9854 103.967 94.3854 105.267L49.6997 50.0811Z",
              fill: "url(#paint51_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L94.3854 105.267C92.7783 106.567 91.1211 107.795 89.4068 108.952L49.6997 50.0882V50.0811Z",
              fill: "url(#paint52_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0823L89.4068 108.947C87.6926 110.104 85.9354 111.182 84.1283 112.182L49.7068 50.0752H49.6997V50.0823Z",
              fill: "url(#paint53_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L84.1211 112.188C82.314 113.188 80.464 114.11 78.5783 114.952L49.6997 50.0882V50.0811Z",
              fill: "url(#paint54_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L78.5783 114.945C76.6926 115.788 74.7711 116.545 72.814 117.217L49.6997 50.0811Z",
              fill: "url(#paint55_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6995 50.0823L72.8138 117.218C70.8567 117.889 68.8781 118.475 66.871 118.975L49.6924 50.0752H49.6995V50.0823Z",
              fill: "url(#paint56_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L66.8783 118.981C64.8711 119.481 62.8497 119.895 60.8068 120.217L49.6997 50.0882V50.0811Z",
              fill: "url(#paint57_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L60.8068 120.217C58.764 120.538 56.714 120.774 54.6497 120.917L49.6997 50.0811Z",
              fill: "url(#paint58_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6999 50.0811L54.6499 120.917C52.5856 121.06 50.5213 121.117 48.457 121.081L49.6999 50.0882V50.0811Z",
              fill: "url(#paint59_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.7001 50.0811L48.4572 121.074C46.3929 121.038 44.3286 120.91 42.2715 120.695L49.6929 50.0811H49.7001Z",
              fill: "url(#paint60_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6999 50.0811L42.2785 120.695C40.2213 120.481 38.1785 120.174 36.1499 119.781L49.6999 50.0811Z",
              fill: "url(#paint61_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6999 50.0811L36.1498 119.781C34.1213 119.388 32.1141 118.902 30.1284 118.338L49.6999 50.0811Z",
              fill: "url(#paint62_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L30.1283 118.338C28.1425 117.767 26.1854 117.11 24.2568 116.374L49.7068 50.0811H49.6997Z",
              fill: "url(#paint63_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6999 50.0811L24.2499 116.374C22.3213 115.631 20.4284 114.81 18.5713 113.902L49.6999 50.0811Z",
              fill: "url(#paint64_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6998 50.0811L18.5713 113.902C16.7141 112.995 14.8998 112.01 13.1284 110.945L49.6998 50.0811Z",
              fill: "url(#paint65_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6996 50.0811L13.1282 110.945C11.3567 109.881 9.6353 108.738 7.96387 107.524L49.6996 50.0811Z",
              fill: "url(#paint66_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6998 50.0811L7.95693 107.524C6.28551 106.31 4.67122 105.024 3.10693 103.667L49.6926 50.0811H49.6998Z",
              fill: "url(#paint67_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6997 50.0811L3.11395 103.667C1.55681 102.31 0.0568079 100.888 -1.37891 99.4025L49.6997 50.0811Z",
              fill: "url(#paint68_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6999 50.0811L-1.3787 99.4025C-2.81441 97.9168 -4.18584 96.3668 -5.48584 94.7668L49.6999 50.0811Z",
              fill: "url(#paint69_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.7 50.0811L-5.48567 94.7668C-6.78567 93.1596 -8.01424 91.5025 -9.17139 89.7882L49.6929 50.0811H49.7Z",
              fill: "url(#paint70_linear_8450_2610)",
            },
          }),
          _c("path", {
            attrs: {
              d: "M49.6999 50.0811L-9.17151 89.7882C-10.3287 88.0739 -11.4072 86.3096 -12.4072 84.5025L49.6999 50.0811Z",
              fill: "url(#paint71_linear_8450_2610)",
            },
          }),
          _c("g", { attrs: { filter: "url(#filter0_f_8450_2610)" } }, [
            _c("path", {
              attrs: {
                d: "M49.7 50.0811L-12.4071 84.5025C-13.4071 82.6953 -14.3285 80.8453 -15.1714 78.9596L49.6929 50.0811H49.7Z",
                fill: "url(#paint72_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.7 50.0811L-15.1714 78.9596C-16.0143 77.0739 -16.7714 75.1525 -17.4429 73.1953L49.6928 50.0811H49.7Z",
                fill: "url(#paint73_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6998 50.0811L-17.4431 73.1953C-18.1145 71.2453 -18.7002 69.2596 -19.2002 67.2596L49.6998 50.0811Z",
                fill: "url(#paint74_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.7002 50.0811L-19.1998 67.2596C-19.6998 65.2525 -20.1141 63.2311 -20.4355 61.1882L49.693 50.0811H49.7002Z",
                fill: "url(#paint75_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L-20.4289 61.1882C-20.7503 59.1453 -20.986 57.0953 -21.1289 55.0311L49.7068 50.0811H49.6997Z",
                fill: "url(#paint76_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6998 50.0822L-21.1359 55.0322C-21.2788 52.9679 -21.3359 50.9036 -21.3002 48.8394L49.6927 50.0822H49.6998Z",
                fill: "url(#paint77_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6999 50.0819L-21.293 48.839C-21.2573 46.7748 -21.1287 44.7105 -20.9144 42.6533L49.6999 50.0747V50.0819Z",
                fill: "url(#paint78_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.7002 50.0817L-20.9141 42.6603C-20.6998 40.6032 -20.3926 38.5603 -19.9998 36.5317L49.7002 50.0817Z",
                fill: "url(#paint79_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6998 50.0822L-20.0073 36.5322C-19.6145 34.5036 -19.1288 32.4965 -18.5645 30.5107L49.6927 50.0822H49.6998Z",
                fill: "url(#paint80_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.7 50.0801L-18.5571 30.5086C-17.9857 28.5229 -17.3286 26.5658 -16.5928 24.6372L49.7 50.0872V50.0801Z",
                fill: "url(#paint81_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.7001 50.0822L-16.5928 24.6322C-15.8499 22.7036 -15.0285 20.8108 -14.1213 18.9536L49.7001 50.0822Z",
                fill: "url(#paint82_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6999 50.0812L-14.1216 18.9526C-13.2144 17.0955 -12.2287 15.2812 -11.1644 13.5098L49.6999 50.0812Z",
                fill: "url(#paint83_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0809L-11.1646 13.5095C-10.1003 11.7381 -8.95741 10.0166 -7.74312 8.34521L49.6997 50.0809Z",
                fill: "url(#paint84_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.7 50.0818L-7.75 8.34609C-6.53571 6.67466 -5.25 5.06038 -3.89286 3.49609L49.6929 50.0818H49.7Z",
                fill: "url(#paint85_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6998 50.0825L-3.89307 3.49676C-2.53592 1.93962 -1.1145 0.43962 0.371219 -0.996094L49.6927 50.0825H49.6998Z",
                fill: "url(#paint86_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0822L0.371094 -0.996373C1.85681 -2.43209 3.40681 -3.80352 5.01395 -5.10352L49.6997 50.0822Z",
                fill: "url(#paint87_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6999 50.0824L5.01416 -5.10335C6.6213 -6.40335 8.27845 -7.63192 9.99273 -8.78906L49.6999 50.0752V50.0824Z",
                fill: "url(#paint88_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6998 50.0813L9.99268 -8.79016C11.707 -9.94731 13.4641 -11.0259 15.2712 -12.0259L49.6927 50.0813H49.6998Z",
                fill: "url(#paint89_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6996 50.0804L15.271 -12.0267C17.0781 -13.0267 18.9281 -13.9482 20.8139 -14.791L49.6924 50.0733H49.6996V50.0804Z",
                fill: "url(#paint90_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.7002 50.0808L20.8145 -14.7906C22.7002 -15.6334 24.6216 -16.3906 26.5787 -17.062L49.693 50.0737H49.7002V50.0808Z",
                fill: "url(#paint91_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6996 50.0813L26.5781 -17.0544C28.5281 -17.7258 30.5138 -18.3115 32.521 -18.8115L49.6996 50.0885V50.0813Z",
                fill: "url(#paint92_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6996 50.0801L32.521 -18.8199C34.5281 -19.3199 36.5496 -19.7342 38.5924 -20.0557L49.6996 50.0801Z",
                fill: "url(#paint93_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6999 50.0805L38.5928 -20.048C40.6356 -20.3695 42.6856 -20.6052 44.7499 -20.748L49.6999 50.0877V50.0805Z",
                fill: "url(#paint94_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.7 50.0812L44.75 -20.7546C46.8143 -20.8974 48.8786 -20.9546 50.9429 -20.9188L49.7 50.074V50.0812Z",
                fill: "url(#paint95_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0803L50.9426 -20.9126C53.0068 -20.8769 55.0711 -20.7483 57.1283 -20.534L49.7068 50.0803H49.6997Z",
                fill: "url(#paint96_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L57.1211 -20.5332C59.1783 -20.3189 61.2211 -20.0118 63.2497 -19.6189L49.6997 50.0811Z",
                fill: "url(#paint97_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0823L63.2497 -19.6177C65.2783 -19.2248 67.2854 -18.7391 69.2711 -18.1748L49.6997 50.0823Z",
                fill: "url(#paint98_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6995 50.0818L69.271 -18.1753C71.2567 -17.6039 73.2138 -16.9467 75.1424 -16.211L49.6924 50.0818H49.6995Z",
                fill: "url(#paint99_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6995 50.0819L75.1424 -16.2109C77.071 -15.4681 78.9638 -14.6467 80.821 -13.7395L49.6924 50.0819H49.6995Z",
                fill: "url(#paint100_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0827L80.8283 -13.7388C82.6854 -12.8316 84.4997 -11.8459 86.2711 -10.7816L49.6997 50.0827Z",
                fill: "url(#paint101_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0801L86.2711 -10.7842C88.0426 -9.71989 89.764 -8.57704 91.4354 -7.36275L49.6997 50.0801Z",
                fill: "url(#paint102_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0825L91.4354 -7.36035C93.1068 -6.14607 94.7211 -4.86035 96.2854 -3.50321L49.6997 50.0825Z",
                fill: "url(#paint103_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0802L96.2854 -3.5127C97.8426 -2.15555 99.3426 -0.734124 100.778 0.751591L49.6997 50.073V50.0802Z",
                fill: "url(#paint104_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.082L100.778 0.753418C102.214 2.23913 103.585 3.78913 104.885 5.39628L49.6997 50.082Z",
                fill: "url(#paint105_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0817L104.878 5.396C106.178 7.00314 107.407 8.66028 108.564 10.3746L49.6997 50.0817Z",
                fill: "url(#paint106_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6995 50.0812L108.564 10.374C109.721 12.0883 110.8 13.8455 111.8 15.6526L49.6924 50.074H49.6995V50.0812Z",
                fill: "url(#paint107_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0796L111.807 15.6582C112.807 17.4653 113.728 19.3153 114.571 21.2011L49.7068 50.0796H49.6997Z",
                fill: "url(#paint108_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0812L114.564 21.2026C115.407 23.0884 116.164 25.0098 116.835 26.9669L49.6997 50.0812Z",
                fill: "url(#paint109_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6995 50.0811L116.835 26.9668C117.507 28.9168 118.092 30.9025 118.592 32.9097L49.6924 50.0882L49.6995 50.0811Z",
                fill: "url(#paint110_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0804L118.6 32.9019C119.1 34.909 119.514 36.9304 119.835 38.9733L49.6997 50.0804Z",
                fill: "url(#paint111_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6995 50.0803L119.828 38.9731C120.15 41.016 120.385 43.066 120.528 45.1303L49.6924 50.0803H49.6995Z",
                fill: "url(#paint112_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0809L120.535 45.1309C120.678 47.1951 120.735 49.2594 120.7 51.3237L49.7068 50.0809H49.6997Z",
                fill: "url(#paint113_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L120.693 51.3239C120.657 53.3882 120.528 55.4525 120.314 57.5096L49.6997 50.0882V50.0811Z",
                fill: "url(#paint114_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L120.314 57.5025C120.1 59.5596 119.793 61.6025 119.4 63.6311L49.6997 50.0811Z",
                fill: "url(#paint115_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L119.4 63.6311C119.007 65.6596 118.521 67.6668 117.957 69.6525L49.6997 50.0811Z",
                fill: "url(#paint116_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0823L117.957 69.6538C117.385 71.6395 116.728 73.5966 115.993 75.5252L49.6997 50.0752V50.0823Z",
                fill: "url(#paint117_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L115.993 75.5311C115.25 77.4596 114.428 79.3525 113.521 81.2096L49.6997 50.0811Z",
                fill: "url(#paint118_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L113.521 81.2096C112.614 83.0668 111.628 84.8811 110.564 86.6525L49.6997 50.0811Z",
                fill: "url(#paint119_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L110.564 86.6525C109.5 88.4239 108.357 90.1453 107.143 91.8168L49.6997 50.0811Z",
                fill: "url(#paint120_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L107.143 91.8168C105.928 93.4882 104.643 95.1025 103.285 96.6668L49.6997 50.0811Z",
                fill: "url(#paint121_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L103.285 96.6668C101.928 98.2239 100.507 99.7239 99.0211 101.16L49.6997 50.0811Z",
                fill: "url(#paint122_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L99.0211 101.16C97.5354 102.595 95.9854 103.967 94.3854 105.267L49.6997 50.0811Z",
                fill: "url(#paint123_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L94.3854 105.267C92.7783 106.567 91.1211 107.795 89.4068 108.952L49.6997 50.0882V50.0811Z",
                fill: "url(#paint124_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0823L89.4068 108.947C87.6926 110.104 85.9354 111.182 84.1283 112.182L49.7068 50.0752H49.6997V50.0823Z",
                fill: "url(#paint125_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L84.1211 112.188C82.314 113.188 80.464 114.11 78.5783 114.952L49.6997 50.0882V50.0811Z",
                fill: "url(#paint126_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L78.5783 114.945C76.6926 115.788 74.7711 116.545 72.814 117.217L49.6997 50.0811Z",
                fill: "url(#paint127_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6995 50.0823L72.8138 117.218C70.8567 117.889 68.8781 118.475 66.871 118.975L49.6924 50.0752H49.6995V50.0823Z",
                fill: "url(#paint128_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L66.8783 118.981C64.8711 119.481 62.8497 119.895 60.8068 120.217L49.6997 50.0882V50.0811Z",
                fill: "url(#paint129_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L60.8068 120.217C58.764 120.538 56.714 120.774 54.6497 120.917L49.6997 50.0811Z",
                fill: "url(#paint130_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6999 50.0811L54.6499 120.917C52.5856 121.06 50.5213 121.117 48.457 121.081L49.6999 50.0882V50.0811Z",
                fill: "url(#paint131_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.7001 50.0811L48.4572 121.074C46.3929 121.038 44.3286 120.91 42.2715 120.695L49.6929 50.0811H49.7001Z",
                fill: "url(#paint132_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6999 50.0811L42.2785 120.695C40.2213 120.481 38.1785 120.174 36.1499 119.781L49.6999 50.0811Z",
                fill: "url(#paint133_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6999 50.0811L36.1498 119.781C34.1213 119.388 32.1141 118.902 30.1284 118.338L49.6999 50.0811Z",
                fill: "url(#paint134_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L30.1283 118.338C28.1425 117.767 26.1854 117.11 24.2568 116.374L49.7068 50.0811H49.6997Z",
                fill: "url(#paint135_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6999 50.0811L24.2499 116.374C22.3213 115.631 20.4284 114.81 18.5713 113.902L49.6999 50.0811Z",
                fill: "url(#paint136_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6998 50.0811L18.5713 113.902C16.7141 112.995 14.8998 112.01 13.1284 110.945L49.6998 50.0811Z",
                fill: "url(#paint137_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6996 50.0811L13.1282 110.945C11.3567 109.881 9.6353 108.738 7.96387 107.524L49.6996 50.0811Z",
                fill: "url(#paint138_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6998 50.0811L7.95693 107.524C6.28551 106.31 4.67122 105.024 3.10693 103.667L49.6926 50.0811H49.6998Z",
                fill: "url(#paint139_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6997 50.0811L3.11395 103.667C1.55681 102.31 0.0568079 100.888 -1.37891 99.4025L49.6997 50.0811Z",
                fill: "url(#paint140_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6999 50.0811L-1.3787 99.4025C-2.81441 97.9168 -4.18584 96.3668 -5.48584 94.7668L49.6999 50.0811Z",
                fill: "url(#paint141_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.7 50.0811L-5.48567 94.7668C-6.78567 93.1596 -8.01424 91.5025 -9.17139 89.7882L49.6929 50.0811H49.7Z",
                fill: "url(#paint142_linear_8450_2610)",
              },
            }),
            _c("path", {
              attrs: {
                d: "M49.6999 50.0811L-9.17151 89.7882C-10.3287 88.0739 -11.4072 86.3096 -12.4072 84.5025L49.6999 50.0811Z",
                fill: "url(#paint143_linear_8450_2610)",
              },
            }),
          ]),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "overlay" },
              attrs: { filter: "url(#filter1_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M46.6858 9.1285C47.7644 9.1285 48.8501 9.18564 49.9215 9.2785C48.8501 9.3785 47.7858 9.50707 46.7287 9.6785C37.2287 11.1928 28.5786 15.7142 22.0072 22.2999C15.4215 28.8714 10.9001 37.5214 9.38579 47.0214C9.21436 48.0785 9.07865 49.1428 8.98579 50.2142C8.88579 49.1428 8.83579 48.0642 8.83579 46.9785C8.75008 37.2214 12.8429 27.2714 19.9429 20.2356C26.9858 13.1285 36.9287 9.03564 46.6858 9.1285Z",
                  fill: "#00EAFF",
                },
              }),
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "hard-light" },
              attrs: { filter: "url(#filter2_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M46.7005 9.29863C47.7719 9.24863 48.8505 9.24149 49.9219 9.2772C48.8505 9.31292 47.779 9.39149 46.7148 9.50578C37.1362 10.5201 28.079 14.9058 21.3648 21.6558C14.6219 28.3772 10.229 37.4272 9.21476 47.0058C9.10047 48.0701 9.0219 49.1343 8.98619 50.2129C8.95047 49.1415 8.95762 48.0629 9.00762 46.9915C9.4219 37.3129 13.6433 27.7701 20.5862 20.8772C27.479 13.9343 37.0219 9.70578 46.7005 9.29863Z",
                  fill: "url(#paint144_linear_8450_2610)",
                },
              }),
            ]
          ),
          _c("g", { attrs: { filter: "url(#filter3_f_8450_2610)" } }, [
            _c(
              "g",
              {
                staticStyle: { "mix-blend-mode": "hard-light" },
                attrs: { opacity: "0.6" },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M46.7005 9.29912C47.7719 9.24912 48.8505 9.24198 49.9219 9.27769C48.8505 9.31341 47.779 9.39198 46.7148 9.50626C37.1362 10.5205 28.079 14.9063 21.3648 21.6563C14.6219 28.3777 10.229 37.4277 9.21476 47.0063C9.10047 48.0706 9.0219 49.1348 8.98619 50.2134C8.95047 49.142 8.95762 48.0634 9.00762 46.992C9.4219 37.3134 13.6433 27.7706 20.5862 20.8777C27.479 13.9348 37.0219 9.70626 46.7005 9.29912Z",
                    fill: "url(#paint145_linear_8450_2610)",
                  },
                }),
              ]
            ),
          ]),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "hard-light" },
              attrs: { filter: "url(#filter4_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M46.6998 9.26896C47.7713 9.2261 48.8498 9.2261 49.9213 9.26896C48.8498 9.31182 47.7784 9.39753 46.7213 9.5261C37.1498 10.619 28.1641 15.0261 21.4641 21.7475C14.7427 28.4475 10.3356 37.4332 9.2427 47.0047C9.12127 48.069 9.03556 49.1332 8.98556 50.2047C8.9427 49.1332 8.93556 48.0547 8.98556 46.9832C9.32127 37.2904 13.5284 27.6904 20.4927 20.7761C27.407 13.8118 37.0141 9.60467 46.6998 9.26896Z",
                  fill: "url(#paint146_linear_8450_2610)",
                },
              }),
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "overlay" },
              attrs: { filter: "url(#filter5_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  opacity: "0.4",
                  d: "M93.7002 50.2134C93.7002 55.9705 92.5645 61.6705 90.3645 66.9848C88.1645 72.2991 84.9359 77.1348 80.8716 81.2062C76.8074 85.2777 71.9788 88.5062 66.6574 90.7062C61.3431 92.9062 55.6431 94.0419 49.8931 94.0419V88.2491C54.8859 88.2491 59.8288 87.2634 64.4431 85.3562C69.0574 83.4419 73.2431 80.6419 76.7788 77.1134C80.3074 73.5848 83.1074 69.3848 85.0216 64.7705C86.9288 60.1562 87.9145 55.2062 87.9145 50.2134H93.7074H93.7002Z",
                  fill: "url(#paint147_linear_8450_2610)",
                },
              }),
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "overlay" },
              attrs: { filter: "url(#filter6_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M90.6856 50.2614C90.6856 27.7614 72.4427 9.51854 49.9427 9.51854C27.4427 9.51854 9.19987 27.7614 9.19987 50.2614C9.19987 72.7614 27.4427 91.0042 49.9427 91.0042V91.1971H49.4142C27.2284 90.9114 9.29273 72.9828 9.01416 50.79V50.2614C9.01416 27.6543 27.3356 9.32568 49.9427 9.32568H50.4713C72.8356 9.6114 90.8784 27.8328 90.8784 50.2614V50.79C90.5927 73.1543 72.3784 91.1971 49.9427 91.1971V91.0042C72.4427 91.0042 90.6856 72.7614 90.6856 50.2614Z",
                  fill: "url(#paint148_linear_8450_2610)",
                },
              }),
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "overlay" },
              attrs: { filter: "url(#filter7_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M90.6856 50.2614C90.6856 27.7614 72.4427 9.51854 49.9427 9.51854C27.4427 9.51854 9.19987 27.7614 9.19987 50.2614C9.19987 72.7614 27.4427 91.0042 49.9427 91.0042V91.1971H49.4142C27.2284 90.9114 9.29273 72.9828 9.01416 50.79V50.2614C9.01416 27.6543 27.3356 9.32568 49.9427 9.32568H50.4713C72.8356 9.6114 90.8784 27.8328 90.8784 50.2614V50.79C90.5927 73.1543 72.3784 91.1971 49.9427 91.1971V91.0042C72.4427 91.0042 90.6856 72.7614 90.6856 50.2614Z",
                  fill: "url(#paint149_linear_8450_2610)",
                },
              }),
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "overlay" },
              attrs: { filter: "url(#filter8_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M90.6856 50.2614C90.6856 27.7614 72.4427 9.51854 49.9427 9.51854C27.4427 9.51854 9.19987 27.7614 9.19987 50.2614C9.19987 72.7614 27.4427 91.0042 49.9427 91.0042V91.1971H49.4142C27.2284 90.9114 9.29273 72.9828 9.01416 50.79V50.2614C9.01416 27.6543 27.3356 9.32568 49.9427 9.32568H50.4713C72.8356 9.6114 90.8784 27.8328 90.8784 50.2614V50.79C90.5927 73.1543 72.3784 91.1971 49.9427 91.1971V91.0042C72.4427 91.0042 90.6856 72.7614 90.6856 50.2614Z",
                  fill: "white",
                },
              }),
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "overlay" },
              attrs: { filter: "url(#filter9_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M90.6856 50.2614C90.6856 27.7614 72.4427 9.51854 49.9427 9.51854C27.4427 9.51854 9.19987 27.7614 9.19987 50.2614C9.19987 72.7614 27.4427 91.0042 49.9427 91.0042V91.1971H49.4142C27.2284 90.9114 9.29273 72.9828 9.01416 50.79V50.2614C9.01416 27.6543 27.3356 9.32568 49.9427 9.32568H50.4713C72.8356 9.6114 90.8784 27.8328 90.8784 50.2614V50.79C90.5927 73.1543 72.3784 91.1971 49.9427 91.1971V91.0042C72.4427 91.0042 90.6856 72.7614 90.6856 50.2614Z",
                  fill: "url(#paint150_linear_8450_2610)",
                },
              }),
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "screen" },
              attrs: { filter: "url(#filter10_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M90.5284 50.2614C90.5284 27.8471 72.357 9.67568 49.9427 9.67568C27.5284 9.67568 9.35702 27.8471 9.35702 50.2614C9.35702 72.6757 27.5284 90.8471 49.9427 90.8471V91.1971H49.4142C27.2284 90.9114 9.29273 72.9828 9.01416 50.79V50.2614C9.01416 27.6543 27.3356 9.32568 49.9427 9.32568H50.4713C72.8356 9.6114 90.8784 27.8328 90.8784 50.2614V50.79C90.5927 73.1543 72.3713 91.1971 49.9427 91.1971V90.8471C72.357 90.8471 90.5284 72.6757 90.5284 50.2614Z",
                  fill: "url(#paint151_linear_8450_2610)",
                },
              }),
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "hard-light" },
              attrs: { filter: "url(#filter11_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M90.1785 50.2614C90.1785 28.04 72.1642 10.0257 49.9427 10.0257C27.7213 10.0257 9.70702 28.04 9.70702 50.2614C9.70702 72.4828 27.7213 90.4971 49.9427 90.4971V91.1971H49.4142C27.2284 90.9114 9.29273 72.9828 9.01416 50.79V50.2614C9.01416 27.6543 27.3356 9.32568 49.9427 9.32568H50.4713C72.8356 9.6114 90.8784 27.8328 90.8784 50.2614V50.79C90.5927 73.1543 72.3784 91.1971 49.9427 91.1971V90.4971C72.1642 90.4971 90.1785 72.4828 90.1785 50.2614Z",
                  fill: "url(#paint152_linear_8450_2610)",
                },
              }),
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "multiply" },
              attrs: { filter: "url(#filter12_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M82.329 50.265C82.329 32.3793 67.829 17.8793 49.9433 17.8793C32.0575 17.8793 17.5575 32.3793 17.5575 50.265C17.5575 68.1508 32.0575 82.6507 49.9433 82.6507V83.365H49.5147C31.5718 83.1365 17.0718 68.6365 16.8433 50.6936V50.265C16.8433 31.9865 31.6575 17.165 49.9433 17.165H50.3718C68.4575 17.3936 83.0433 32.1293 83.0433 50.265V50.6936C82.8147 68.7793 68.079 83.365 49.9433 83.365V82.6507C67.829 82.6507 82.329 68.1508 82.329 50.265Z",
                  fill: "black",
                },
              }),
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "overlay" },
              attrs: { opacity: "0.7", filter: "url(#filter13_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M82.329 50.265C82.329 32.3793 67.829 17.8793 49.9433 17.8793C32.0575 17.8793 17.5575 32.3793 17.5575 50.265C17.5575 68.1508 32.0575 82.6507 49.9433 82.6507V83.365H49.5147C31.5718 83.1365 17.0718 68.6365 16.8433 50.6936V50.265C16.8433 31.9865 31.6575 17.165 49.9433 17.165H50.3718C68.4575 17.3936 83.0433 32.1293 83.0433 50.265V50.6936C82.8075 68.7793 68.079 83.365 49.9433 83.365V82.6507C67.829 82.6507 82.329 68.1508 82.329 50.265Z",
                  fill: "black",
                },
              }),
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "overlay" },
              attrs: { filter: "url(#filter14_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  opacity: "0.4",
                  d: "M93.7002 50.2134C93.7002 55.9705 92.5645 61.6705 90.3645 66.9848C88.1645 72.2991 84.9359 77.1348 80.8716 81.2062C76.8074 85.2777 71.9788 88.5062 66.6574 90.7062C61.3431 92.9062 55.6431 94.0419 49.8931 94.0419V88.2491C54.8859 88.2491 59.8288 87.2634 64.4431 85.3562C69.0574 83.4419 73.2431 80.6419 76.7788 77.1134C80.3074 73.5848 83.1074 69.3848 85.0216 64.7705C86.9288 60.1562 87.9145 55.2062 87.9145 50.2134H93.7074H93.7002Z",
                  fill: "url(#paint153_linear_8450_2610)",
                },
              }),
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "overlay" },
              attrs: { opacity: "0.2", filter: "url(#filter15_f_8450_2610)" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M46.6858 9.1285C47.7644 9.1285 48.8501 9.18564 49.9215 9.2785C48.8501 9.3785 47.7858 9.50707 46.7287 9.6785C37.2287 11.1928 28.5786 15.7142 22.0072 22.2999C15.4215 28.8714 10.9001 37.5214 9.38579 47.0214C9.21436 48.0785 9.07865 49.1428 8.98579 50.2142C8.88579 49.1428 8.83579 48.0642 8.83579 46.9785C8.75008 37.2214 12.8429 27.2714 19.9429 20.2356C26.9858 13.1285 36.9287 9.03564 46.6858 9.1285Z",
                  fill: "#00EAFF",
                },
              }),
            ]
          ),
        ]),
      ]),
      _c(
        "defs",
        [
          _c(
            "filter",
            {
              attrs: {
                id: "filter0_f_8450_2610",
                x: "-38.4534",
                y: "-38.0721",
                width: "176.306",
                height: "176.306",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "8.57143",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter1_f_8450_2610",
                x: "-4.02267",
                y: "-3.73019",
                width: "66.8012",
                height: "66.8017",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "6.42857",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter2_f_8450_2610",
                x: "1.82101",
                y: "2.11203",
                width: "55.2437",
                height: "55.2437",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "3.57143",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter3_f_8450_2610",
                x: "1.82101",
                y: "2.11251",
                width: "55.2437",
                height: "55.2437",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "3.57143",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter4_f_8450_2610",
                x: "3.2364",
                y: "3.52253",
                width: "52.3993",
                height: "52.3963",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "2.85714",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter5_f_8450_2610",
                x: "37.0359",
                y: "37.3562",
                width: "69.5287",
                height: "69.5429",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "6.42857",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter6_f_8450_2610",
                x: "-3.84298",
                y: "-3.53146",
                width: "107.579",
                height: "107.586",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "6.42857",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter7_f_8450_2610",
                x: "1.8713",
                y: "2.18283",
                width: "96.15",
                height: "96.1573",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "3.57143",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter8_f_8450_2610",
                x: "1.8713",
                y: "2.18283",
                width: "96.15",
                height: "96.1573",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "3.57143",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter9_f_8450_2610",
                x: "3.29987",
                y: "3.6114",
                width: "93.2928",
                height: "93.3002",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "2.85714",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter10_f_8450_2610",
                x: "1.8713",
                y: "2.18283",
                width: "96.15",
                height: "96.1573",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "3.57143",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter11_f_8450_2610",
                x: "3.29987",
                y: "3.6114",
                width: "93.2928",
                height: "93.3002",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "2.85714",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter12_f_8450_2610",
                x: "8.27183",
                y: "8.59361",
                width: "83.3431",
                height: "83.3431",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "4.28571",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter13_f_8450_2610",
                x: "3.98612",
                y: "4.3079",
                width: "91.9145",
                height: "91.9145",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "6.42857",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter14_f_8450_2610",
                x: "37.0359",
                y: "37.3562",
                width: "69.5287",
                height: "69.5429",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "6.42857",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter15_f_8450_2610",
                x: "-4.02267",
                y: "-3.73019",
                width: "66.8012",
                height: "66.8017",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "6.42857",
                  result: "effect1_foregroundBlur_8450_2610",
                },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_8450_2610",
                x1: "25.8215",
                y1: "62.2525",
                x2: "3.98576",
                y2: "72.9882",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#19BAFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#0FB0FF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint1_linear_8450_2610",
                x1: "25.7286",
                y1: "59.4882",
                x2: "2.40713",
                y2: "68.6953",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#16B5FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#0EADFF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint2_linear_8450_2610",
                x1: "24.9927",
                y1: "57.7596",
                x2: "1.17123",
                y2: "64.6168",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#16B5FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#10A9FF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint3_linear_8450_2610",
                x1: "24.7002",
                y1: "55.1882",
                x2: "1.35017",
                y2: "59.9311",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#16B1FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#10A5FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint4_linear_8450_2610",
                x1: "24.8068",
                y1: "52.8668",
                x2: "1.25681",
                y2: "55.5739",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#15A9FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#11A1FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint5_linear_8450_2610",
                x1: "25.1998",
                y1: "50.6251",
                x2: "0.66409",
                y2: "51.3179",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#159FFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#129DFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint6_linear_8450_2610",
                x1: "25.6499",
                y1: "48.2962",
                x2: "0.307031",
                y2: "46.9105",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1699FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1591FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint7_linear_8450_2610",
                x1: "26.1574",
                y1: "45.8175",
                x2: "0.71451",
                y2: "42.4246",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1591FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1785FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint8_linear_8450_2610",
                x1: "25.8998",
                y1: "44.5179",
                x2: "2.1641",
                y2: "38.7393",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1487FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#187FFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint9_linear_8450_2610",
                x1: "26.7857",
                y1: "41.9086",
                x2: "3.32859",
                y2: "34.3301",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#157FFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1973FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint10_linear_8450_2610",
                x1: "27.3072",
                y1: "40.4679",
                x2: "4.84294",
                y2: "30.6322",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1777FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1B6CFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint11_linear_8450_2610",
                x1: "27.657",
                y1: "38.0526",
                x2: "6.41413",
                y2: "26.5455",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1771FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1D62FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint12_linear_8450_2610",
                x1: "29.0069",
                y1: "36.7809",
                x2: "8.97831",
                y2: "23.3166",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#186AFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1C59FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint13_linear_8450_2610",
                x1: "30.6",
                y1: "34.4961",
                x2: "11.45",
                y2: "19.4747",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1962FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1E53FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint14_linear_8450_2610",
                x1: "31.9498",
                y1: "32.6325",
                x2: "14.2855",
                y2: "16.1896",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1A5CFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1F4FFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint15_linear_8450_2610",
                x1: "33.2568",
                y1: "31.3822",
                x2: "17.5568",
                y2: "13.6965",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1B57FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2246FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint16_linear_8450_2610",
                x1: "35.1713",
                y1: "29.6824",
                x2: "20.757",
                y2: "10.5967",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1E52FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2343FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint17_linear_8450_2610",
                x1: "36.4855",
                y1: "28.8241",
                x2: "24.0998",
                y2: "8.45269",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#204DFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#263DFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint18_linear_8450_2610",
                x1: "38.3853",
                y1: "27.2733",
                x2: "27.8924",
                y2: "6.2947",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2049FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2838FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint19_linear_8450_2610",
                x1: "40.1787",
                y1: "26.0809",
                x2: "31.793",
                y2: "4.70228",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2245FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2935FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint20_linear_8450_2610",
                x1: "42.3067",
                y1: "25.3099",
                x2: "35.8781",
                y2: "3.51705",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2641FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2B32FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint21_linear_8450_2610",
                x1: "44.6996",
                y1: "25.0801",
                x2: "40.0281",
                y2: "2.34434",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#273EFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2D2DFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint22_linear_8450_2610",
                x1: "47.0856",
                y1: "24.602",
                x2: "44.3071",
                y2: "1.53053",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2A3BFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2E2CFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint23_linear_8450_2610",
                x1: "48.9143",
                y1: "24.1669",
                x2: "48.3714",
                y2: "1.36687",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2F38FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2F28FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint24_linear_8450_2610",
                x1: "51.0497",
                y1: "24.8303",
                x2: "52.6068",
                y2: "1.08026",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#3336FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#3C22FE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint25_linear_8450_2610",
                x1: "53.2068",
                y1: "24.7597",
                x2: "56.814",
                y2: "1.5668",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#3931FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#3C22FE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint26_linear_8450_2610",
                x1: "56.214",
                y1: "25.2038",
                x2: "61.5354",
                y2: "1.83233",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#3D30FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#4120FE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint27_linear_8450_2610",
                x1: "57.371",
                y1: "25.0676",
                x2: "65.1352",
                y2: "2.96042",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#422DFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#441DFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint28_linear_8450_2610",
                x1: "59.821",
                y1: "25.2319",
                x2: "68.6638",
                y2: "5.65335",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#4729FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#471CFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint29_linear_8450_2610",
                x1: "62.314",
                y1: "27.0112",
                x2: "73.0711",
                y2: "7.11837",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#4B27FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#4E19FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint30_linear_8450_2610",
                x1: "63.7426",
                y1: "28.2658",
                x2: "76.7997",
                y2: "8.84439",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#5225FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#5416FE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint31_linear_8450_2610",
                x1: "65.5069",
                y1: "28.9396",
                x2: "79.8569",
                y2: "11.5468",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#5821FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#5813FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint32_linear_8450_2610",
                x1: "67.2711",
                y1: "30.9444",
                x2: "83.1711",
                y2: "14.5016",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#5C20FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#5C12FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint33_linear_8450_2610",
                x1: "69.4283",
                y1: "32.6391",
                x2: "87.0926",
                y2: "17.0034",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#621DFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#6210FC" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint34_linear_8450_2610",
                x1: "70.764",
                y1: "34.6531",
                x2: "89.3069",
                y2: "20.8531",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#651BFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#670CFD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint35_linear_8450_2610",
                x1: "71.7852",
                y1: "36.3669",
                x2: "91.4781",
                y2: "24.3883",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#6B1AFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#6C0CFC" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint36_linear_8450_2610",
                x1: "73.1711",
                y1: "38.1296",
                x2: "95.0283",
                y2: "27.3725",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7116FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#710AFC" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint37_linear_8450_2610",
                x1: "73.6854",
                y1: "40.5884",
                x2: "96.4211",
                y2: "31.6598",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7615FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#7309FB" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint38_linear_8450_2610",
                x1: "74.6567",
                y1: "42.4239",
                x2: "97.0567",
                y2: "35.9311",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7813FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#7809FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint39_linear_8450_2610",
                x1: "75.2211",
                y1: "45.459",
                x2: "98.364",
                y2: "40.4519",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7A13FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#7B08FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint40_linear_8450_2610",
                x1: "75.2638",
                y1: "47.4874",
                x2: "98.7495",
                y2: "44.6446",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8114FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#8007FB" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint41_linear_8450_2610",
                x1: "75.7569",
                y1: "49.1094",
                x2: "98.764",
                y2: "48.6523",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8114FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#8007FB" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint42_linear_8450_2610",
                x1: "75.4997",
                y1: "50.4025",
                x2: "98.7783",
                y2: "52.4811",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8315FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#8109FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint43_linear_8450_2610",
                x1: "75.1283",
                y1: "53.2811",
                x2: "99.4926",
                y2: "57.2453",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8315FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#8109FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint44_linear_8450_2610",
                x1: "74.7426",
                y1: "55.7025",
                x2: "99.014",
                y2: "61.7453",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8419FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#8109FB" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint45_linear_8450_2610",
                x1: "73.8783",
                y1: "58.5538",
                x2: "97.1569",
                y2: "66.1395",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8419FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#800AFA" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint46_linear_8450_2610",
                x1: "72.8283",
                y1: "60.4739",
                x2: "95.0211",
                y2: "69.9453",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#841AFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#810CFC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint47_linear_8450_2610",
                x1: "72.0283",
                y1: "61.8311",
                x2: "94.6997",
                y2: "74.3525",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#821CFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#7E0DFA" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint48_linear_8450_2610",
                x1: "71.2068",
                y1: "64.2168",
                x2: "92.3854",
                y2: "78.2953",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8221FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#7C11FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint49_linear_8450_2610",
                x1: "69.0783",
                y1: "66.1096",
                x2: "88.6354",
                y2: "81.3311",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7F24FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#7A16FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint50_linear_8450_2610",
                x1: "67.6997",
                y1: "68.2453",
                x2: "85.0211",
                y2: "84.1239",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7E29FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#751BFC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint51_linear_8450_2610",
                x1: "66.4854",
                y1: "68.8525",
                x2: "82.2783",
                y2: "86.8025",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#792FFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#7121FD" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint52_linear_8450_2610",
                x1: "64.4497",
                y1: "70.6311",
                x2: "78.7068",
                y2: "89.5739",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7732FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#6F28FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint53_linear_8450_2610",
                x1: "62.6426",
                y1: "71.4038",
                x2: "75.0926",
                y2: "91.6181",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7438FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#692DFC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint54_linear_8450_2610",
                x1: "61.5711",
                y1: "72.4596",
                x2: "71.9426",
                y2: "94.0239",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#713FFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#6434FC" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint55_linear_8450_2610",
                x1: "58.3354",
                y1: "73.4739",
                x2: "67.2711",
                y2: "95.4025",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#6C48FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#623BFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint56_linear_8450_2610",
                x1: "56.9495",
                y1: "74.0323",
                x2: "63.5852",
                y2: "96.7038",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#6651FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#5C42FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint57_linear_8450_2610",
                x1: "55.2783",
                y1: "75.3025",
                x2: "59.6069",
                y2: "97.7025",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#615AFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#594BFD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint58_linear_8450_2610",
                x1: "52.3568",
                y1: "74.3953",
                x2: "55.1997",
                y2: "98.8239",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#5E61FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#5554FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint59_linear_8450_2610",
                x1: "51.5499",
                y1: "74.7882",
                x2: "51.5499",
                y2: "98.6739",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.02", "stop-color": "#576BFF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#4A62FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint60_linear_8450_2610",
                x1: "48.4001",
                y1: "74.9525",
                x2: "46.8715",
                y2: "98.1382",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.02", "stop-color": "#5174FF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#466DFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint61_linear_8450_2610",
                x1: "46.4142",
                y1: "74.2882",
                x2: "42.6928",
                y2: "98.0382",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.02", "stop-color": "#4B80FF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#3E79FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint62_linear_8450_2610",
                x1: "43.5284",
                y1: "73.6382",
                x2: "38.2499",
                y2: "96.7168",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.01", "stop-color": "#458AFF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#3981FE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint63_linear_8450_2610",
                x1: "41.8711",
                y1: "72.7811",
                x2: "34.564",
                y2: "94.9811",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.01", "stop-color": "#4090FF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#338FFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint64_linear_8450_2610",
                x1: "39.9499",
                y1: "71.8882",
                x2: "31.0141",
                y2: "92.7311",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.01", "stop-color": "#3A9BFF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2F9BFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint65_linear_8450_2610",
                x1: "38.0998",
                y1: "71.4025",
                x2: "23.3427",
                y2: "98.6025",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.02", "stop-color": "#34A3FF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#269BFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint66_linear_8450_2610",
                x1: "35.1496",
                y1: "72.1382",
                x2: "17.9639",
                y2: "98.0525",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2FAEFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#1D9CFE" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint67_linear_8450_2610",
                x1: "30.5641",
                y1: "74.1525",
                x2: "12.2427",
                y2: "97.1596",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2BB5FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#14A1FF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint68_linear_8450_2610",
                x1: "27.8425",
                y1: "72.4453",
                x2: "8.26395",
                y2: "93.5596",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#23BAFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#10A5FF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint69_linear_8450_2610",
                x1: "26.6856",
                y1: "70.3453",
                x2: "8.19273",
                y2: "86.7668",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#20BBFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#10ABFF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint70_linear_8450_2610",
                x1: "25.9358",
                y1: "67.8739",
                x2: "6.62862",
                y2: "82.0382",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1CBBFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#10ADFF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint71_linear_8450_2610",
                x1: "25.9713",
                y1: "64.5739",
                x2: "5.39992",
                y2: "77.2025",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1BBCFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#0FAEFF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint72_linear_8450_2610",
                x1: "25.8215",
                y1: "62.2525",
                x2: "3.98576",
                y2: "72.9882",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#00C4FF" } }),
              _c("stop", {
                attrs: { offset: "0.45", "stop-color": "#1BBCFF" },
              }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#0FAEFF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint73_linear_8450_2610",
                x1: "25.7286",
                y1: "59.4882",
                x2: "2.40713",
                y2: "68.6953",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1CBBFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#10ADFF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint74_linear_8450_2610",
                x1: "24.9927",
                y1: "57.7596",
                x2: "1.17123",
                y2: "64.6168",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#16B5FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#10A9FF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint75_linear_8450_2610",
                x1: "24.7002",
                y1: "55.1882",
                x2: "1.35017",
                y2: "59.9311",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#16B1FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#10A5FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint76_linear_8450_2610",
                x1: "24.8068",
                y1: "52.8668",
                x2: "1.25681",
                y2: "55.5739",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#15A9FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#11A1FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint77_linear_8450_2610",
                x1: "25.1998",
                y1: "50.6251",
                x2: "0.66409",
                y2: "51.3179",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#159FFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#129DFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint78_linear_8450_2610",
                x1: "25.6499",
                y1: "48.2962",
                x2: "0.307031",
                y2: "46.9105",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1699FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1591FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint79_linear_8450_2610",
                x1: "26.1574",
                y1: "45.8175",
                x2: "0.71451",
                y2: "42.4246",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1591FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1785FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint80_linear_8450_2610",
                x1: "25.8998",
                y1: "44.5179",
                x2: "2.1641",
                y2: "38.7393",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1487FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#187FFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint81_linear_8450_2610",
                x1: "26.7857",
                y1: "41.9086",
                x2: "3.32859",
                y2: "34.3301",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#157FFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1973FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint82_linear_8450_2610",
                x1: "27.3072",
                y1: "40.4679",
                x2: "4.84294",
                y2: "30.6322",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1774FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1A6AFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint83_linear_8450_2610",
                x1: "27.657",
                y1: "38.0526",
                x2: "6.41413",
                y2: "26.5455",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1771FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1D62FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint84_linear_8450_2610",
                x1: "29.0069",
                y1: "36.7809",
                x2: "8.97831",
                y2: "23.3166",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#186AFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1C59FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint85_linear_8450_2610",
                x1: "30.6",
                y1: "34.4961",
                x2: "11.45",
                y2: "19.4747",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1962FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1E53FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint86_linear_8450_2610",
                x1: "31.9498",
                y1: "32.6325",
                x2: "14.2855",
                y2: "16.1896",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1A5CFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1F4FFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint87_linear_8450_2610",
                x1: "33.2568",
                y1: "31.3822",
                x2: "17.5568",
                y2: "13.6965",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1B57FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2246FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint88_linear_8450_2610",
                x1: "35.1713",
                y1: "29.6824",
                x2: "20.757",
                y2: "10.5967",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1E52FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2343FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint89_linear_8450_2610",
                x1: "36.4855",
                y1: "28.8241",
                x2: "24.0998",
                y2: "8.45269",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#204DFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#263DFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint90_linear_8450_2610",
                x1: "38.3853",
                y1: "27.2733",
                x2: "27.8924",
                y2: "6.2947",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2049FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2838FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint91_linear_8450_2610",
                x1: "40.1787",
                y1: "26.0809",
                x2: "31.793",
                y2: "4.70228",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2245FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2935FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint92_linear_8450_2610",
                x1: "42.3067",
                y1: "25.3099",
                x2: "35.8781",
                y2: "3.51705",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2641FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2B32FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint93_linear_8450_2610",
                x1: "44.6996",
                y1: "25.0801",
                x2: "40.0281",
                y2: "2.34434",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#273EFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2D2DFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint94_linear_8450_2610",
                x1: "47.0856",
                y1: "24.602",
                x2: "44.3071",
                y2: "1.53053",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2A3BFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2E2CFF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint95_linear_8450_2610",
                x1: "48.9143",
                y1: "24.1669",
                x2: "48.3714",
                y2: "1.36687",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2F38FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2F28FF" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint96_linear_8450_2610",
                x1: "51.0497",
                y1: "24.8303",
                x2: "52.6068",
                y2: "1.08026",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#3336FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#3C22FE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint97_linear_8450_2610",
                x1: "53.2068",
                y1: "24.7597",
                x2: "56.814",
                y2: "1.5668",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#3931FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#3C22FE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint98_linear_8450_2610",
                x1: "56.214",
                y1: "25.2038",
                x2: "61.5354",
                y2: "1.83233",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#3D30FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#4120FE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint99_linear_8450_2610",
                x1: "57.371",
                y1: "25.0676",
                x2: "65.1352",
                y2: "2.96042",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#422DFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#441DFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint100_linear_8450_2610",
                x1: "59.821",
                y1: "25.2319",
                x2: "68.6638",
                y2: "5.65335",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#4729FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#471CFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint101_linear_8450_2610",
                x1: "62.314",
                y1: "27.0112",
                x2: "73.0711",
                y2: "7.11837",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#4B27FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#4E19FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint102_linear_8450_2610",
                x1: "63.7426",
                y1: "28.2658",
                x2: "76.7997",
                y2: "8.84439",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#5225FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#5416FE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint103_linear_8450_2610",
                x1: "65.5069",
                y1: "28.9396",
                x2: "79.8569",
                y2: "11.5468",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#5821FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#5813FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint104_linear_8450_2610",
                x1: "67.2711",
                y1: "30.9444",
                x2: "83.1711",
                y2: "14.5016",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#5C20FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#5C12FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint105_linear_8450_2610",
                x1: "69.4283",
                y1: "32.6391",
                x2: "87.0926",
                y2: "17.0034",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#621DFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#6210FC" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint106_linear_8450_2610",
                x1: "70.764",
                y1: "34.6531",
                x2: "89.3069",
                y2: "20.8531",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#651BFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#670CFD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint107_linear_8450_2610",
                x1: "71.7852",
                y1: "36.3669",
                x2: "91.4781",
                y2: "24.3883",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#6B1AFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#6C0CFC" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint108_linear_8450_2610",
                x1: "73.1711",
                y1: "38.1296",
                x2: "95.0283",
                y2: "27.3725",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7116FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#710AFC" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint109_linear_8450_2610",
                x1: "73.6854",
                y1: "40.5884",
                x2: "96.4211",
                y2: "31.6598",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7615FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#7309FB" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint110_linear_8450_2610",
                x1: "74.6567",
                y1: "42.4239",
                x2: "97.0567",
                y2: "35.9311",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7813FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#7809FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint111_linear_8450_2610",
                x1: "75.2211",
                y1: "45.459",
                x2: "98.364",
                y2: "40.4519",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7A13FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#7B08FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint112_linear_8450_2610",
                x1: "75.2638",
                y1: "47.4874",
                x2: "98.7495",
                y2: "44.6446",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8114FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#8007FB" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint113_linear_8450_2610",
                x1: "75.7569",
                y1: "49.1094",
                x2: "98.764",
                y2: "48.6523",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8114FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#8007FB" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint114_linear_8450_2610",
                x1: "75.4997",
                y1: "50.4025",
                x2: "98.7783",
                y2: "52.4811",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8315FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#8109FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint115_linear_8450_2610",
                x1: "75.1283",
                y1: "53.2811",
                x2: "99.4926",
                y2: "57.2453",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8315FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#8109FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint116_linear_8450_2610",
                x1: "74.7426",
                y1: "55.7025",
                x2: "99.014",
                y2: "61.7453",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8419FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#8109FB" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint117_linear_8450_2610",
                x1: "73.8783",
                y1: "58.5538",
                x2: "97.1569",
                y2: "66.1395",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8419FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#800AFA" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint118_linear_8450_2610",
                x1: "72.8283",
                y1: "60.4739",
                x2: "95.0211",
                y2: "69.9453",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#841AFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#810CFC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint119_linear_8450_2610",
                x1: "72.0283",
                y1: "61.8311",
                x2: "94.6997",
                y2: "74.3525",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#821CFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#7E0DFA" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint120_linear_8450_2610",
                x1: "71.2068",
                y1: "64.2168",
                x2: "92.3854",
                y2: "78.2953",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#8221FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#7C11FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint121_linear_8450_2610",
                x1: "69.0783",
                y1: "66.1096",
                x2: "88.6354",
                y2: "81.3311",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.13", "stop-color": "#7F24FF" },
              }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#7A16FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint122_linear_8450_2610",
                x1: "67.6997",
                y1: "68.2453",
                x2: "85.0211",
                y2: "84.1239",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7E29FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#751BFC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint123_linear_8450_2610",
                x1: "66.4854",
                y1: "68.8525",
                x2: "82.2783",
                y2: "86.8025",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#792FFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#7121FD" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint124_linear_8450_2610",
                x1: "64.4497",
                y1: "70.6311",
                x2: "78.7068",
                y2: "89.5739",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7732FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#6F28FC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint125_linear_8450_2610",
                x1: "62.6426",
                y1: "71.4038",
                x2: "75.0926",
                y2: "91.6181",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#7438FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#692DFC" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint126_linear_8450_2610",
                x1: "61.5711",
                y1: "72.4596",
                x2: "71.9426",
                y2: "94.0239",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#713FFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#6434FC" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint127_linear_8450_2610",
                x1: "58.3354",
                y1: "73.4739",
                x2: "67.2711",
                y2: "95.4025",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#6C48FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#623BFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint128_linear_8450_2610",
                x1: "56.9495",
                y1: "74.0323",
                x2: "63.5852",
                y2: "96.7038",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#6651FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#5C42FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint129_linear_8450_2610",
                x1: "55.2783",
                y1: "75.3025",
                x2: "59.6069",
                y2: "97.7025",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#615AFF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#594BFD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint130_linear_8450_2610",
                x1: "52.3568",
                y1: "74.3953",
                x2: "55.1997",
                y2: "98.8239",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#5E61FF" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#5554FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint131_linear_8450_2610",
                x1: "51.5499",
                y1: "74.7882",
                x2: "51.5499",
                y2: "98.6739",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.02", "stop-color": "#576BFF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#4A62FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint132_linear_8450_2610",
                x1: "48.4001",
                y1: "74.9525",
                x2: "46.8715",
                y2: "98.1382",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.02", "stop-color": "#5174FF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#466DFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint133_linear_8450_2610",
                x1: "46.4142",
                y1: "74.2882",
                x2: "42.6928",
                y2: "98.0382",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.02", "stop-color": "#4B80FF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#3E79FD" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint134_linear_8450_2610",
                x1: "43.5284",
                y1: "73.6382",
                x2: "38.2499",
                y2: "96.7168",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.01", "stop-color": "#458AFF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#3981FE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint135_linear_8450_2610",
                x1: "41.8711",
                y1: "72.7811",
                x2: "34.564",
                y2: "94.9811",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.01", "stop-color": "#4090FF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#338FFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint136_linear_8450_2610",
                x1: "39.9499",
                y1: "71.8882",
                x2: "31.0141",
                y2: "92.7311",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.01", "stop-color": "#3A9BFF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2F9BFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint137_linear_8450_2610",
                x1: "38.0998",
                y1: "71.4025",
                x2: "23.3427",
                y2: "98.6025",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { offset: "0.02", "stop-color": "#34A3FF" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#269BFE" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint138_linear_8450_2610",
                x1: "35.1496",
                y1: "72.1382",
                x2: "17.9639",
                y2: "98.0525",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2FAEFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#1D9CFE" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint139_linear_8450_2610",
                x1: "30.5641",
                y1: "74.1525",
                x2: "12.2427",
                y2: "97.1596",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2BB5FF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#14A1FF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint140_linear_8450_2610",
                x1: "27.8425",
                y1: "72.4453",
                x2: "8.26395",
                y2: "93.5596",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#1BBCFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#10A5FF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint141_linear_8450_2610",
                x1: "26.6856",
                y1: "70.3453",
                x2: "8.19273",
                y2: "86.7668",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#20BBFF" } }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#10ABFF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint142_linear_8450_2610",
                x1: "25.9358",
                y1: "67.8739",
                x2: "6.62862",
                y2: "82.0382",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#00EEFF" } }),
              _c("stop", {
                attrs: { offset: "0.15", "stop-color": "#1CBBFF" },
              }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#10ADFF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint143_linear_8450_2610",
                x1: "25.9713",
                y1: "64.5739",
                x2: "5.39992",
                y2: "77.2025",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#00FFFF" } }),
              _c("stop", {
                attrs: { offset: "0.66", "stop-color": "#1BBCFF" },
              }),
              _c("stop", {
                attrs: { offset: "0.99", "stop-color": "#0FAEFF" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint144_linear_8450_2610",
                x1: "4.55047",
                y1: "45.7772",
                x2: "45.4862",
                y2: "4.84149",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { "stop-color": "#00EAFF", "stop-opacity": "0.3" },
              }),
              _c("stop", {
                attrs: { offset: "0.35", "stop-color": "#00EAFF" },
              }),
              _c("stop", {
                attrs: { offset: "0.61", "stop-color": "#00EAFF" },
              }),
              _c("stop", {
                attrs: {
                  offset: "1",
                  "stop-color": "#00EAFF",
                  "stop-opacity": "0",
                },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint145_linear_8450_2610",
                x1: "4.55047",
                y1: "45.7777",
                x2: "45.4862",
                y2: "4.84198",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { "stop-color": "#00EAFF", "stop-opacity": "0" },
              }),
              _c("stop", {
                attrs: { offset: "0.35", "stop-color": "#00EAFF" },
              }),
              _c("stop", {
                attrs: {
                  offset: "0.65",
                  "stop-color": "#00EAFF",
                  "stop-opacity": "0",
                },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint146_linear_8450_2610",
                x1: "45.857",
                y1: "6.14753",
                x2: "4.92841",
                y2: "44.7261",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { "stop-color": "#00EAFF", "stop-opacity": "0" },
              }),
              _c("stop", {
                attrs: {
                  offset: "0.62",
                  "stop-color": "white",
                  "stop-opacity": "0.7",
                },
              }),
              _c("stop", {
                attrs: {
                  offset: "1",
                  "stop-color": "#00EAFF",
                  "stop-opacity": "0",
                },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint147_linear_8450_2610",
                x1: "84.0931",
                y1: "83.9348",
                x2: "50.2216",
                y2: "51.3991",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { offset: "0.05", "stop-color": "white" } }),
              _c("stop", {
                attrs: {
                  offset: "0.34",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint148_linear_8450_2610",
                x1: "19.3642",
                y1: "19.6828",
                x2: "80.0784",
                y2: "80.3971",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#00EAFF" } }),
              _c("stop", {
                attrs: {
                  offset: "0.06",
                  "stop-color": "white",
                  "stop-opacity": "0.5",
                },
              }),
              _c("stop", {
                attrs: {
                  offset: "0.29",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
              _c("stop", {
                attrs: {
                  offset: "0.6",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
              _c("stop", { attrs: { offset: "0.92", "stop-color": "white" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint149_linear_8450_2610",
                x1: "19.3642",
                y1: "19.6828",
                x2: "80.0784",
                y2: "80.3971",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#00EAFF" } }),
              _c("stop", {
                attrs: {
                  offset: "0.06",
                  "stop-color": "white",
                  "stop-opacity": "0.5",
                },
              }),
              _c("stop", {
                attrs: {
                  offset: "0.29",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
              _c("stop", {
                attrs: {
                  offset: "0.6",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
              _c("stop", { attrs: { offset: "0.92", "stop-color": "white" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint150_linear_8450_2610",
                x1: "19.3642",
                y1: "19.6828",
                x2: "80.0784",
                y2: "80.3971",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#00EAFF" } }),
              _c("stop", {
                attrs: {
                  offset: "0.06",
                  "stop-color": "white",
                  "stop-opacity": "0.5",
                },
              }),
              _c("stop", {
                attrs: {
                  offset: "0.29",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
              _c("stop", {
                attrs: {
                  offset: "0.6",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
              _c("stop", { attrs: { offset: "0.92", "stop-color": "white" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint151_linear_8450_2610",
                x1: "18.2499",
                y1: "23.3685",
                x2: "81.8213",
                y2: "77.3043",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "white" } }),
              _c("stop", {
                attrs: {
                  offset: "0.4",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
              _c("stop", {
                attrs: {
                  offset: "0.5",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
              _c("stop", {
                attrs: {
                  offset: "0.6",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "white" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint152_linear_8450_2610",
                x1: "18.2499",
                y1: "23.3757",
                x2: "81.8213",
                y2: "77.3043",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "white" } }),
              _c("stop", {
                attrs: {
                  offset: "0.08",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
              _c("stop", {
                attrs: {
                  offset: "0.5",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
              _c("stop", {
                attrs: {
                  offset: "0.9",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "white" } }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint153_linear_8450_2610",
                x1: "84.0931",
                y1: "83.9348",
                x2: "50.2216",
                y2: "51.3991",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { offset: "0.05", "stop-color": "white" } }),
              _c("stop", {
                attrs: {
                  offset: "0.34",
                  "stop-color": "white",
                  "stop-opacity": "0",
                },
              }),
            ],
            1
          ),
          _c("clipPath", { attrs: { id: "clip0_8450_2610" } }, [
            _c("rect", {
              attrs: { width: "100", height: "100", fill: "white" },
            }),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }